import { z } from "zod";

export const getVehiclesSivDataListByCompaniesResponse = z.array(
  z.object({
    vin: z.string(),
    brand: z.string(),
    registrationNumber: z.string(),
    model: z.string(),
    dateMec: z.iso.datetime(),
  }),
);

export type GetVehiclesSivDataListByCompaniesResponse = z.infer<
  typeof getVehiclesSivDataListByCompaniesResponse
>;
